export enum Catalogs {
  Organizations = 'STRUCTURE_UNIT',
  Fields = 'FIELD',
  Crops = 'CROP',
  DevelopmentPhase = 'DEVELOPMENT_PHASE',
  CropRotation = 'CROP_ROTATION',
  WorkHistory = 'WORK_HISTORY',
  VehicleModels = 'AUTO_MODEL',
  AutoTypes = 'AUTO_TYPE',
  TechOperations = 'SOIL_OPERATION',
  SoilOperationTypes = 'SOIL_OPERATION_TYPE',
  Unit = 'UNIT',
  Consumables = 'CONSUMABLE',
  ConsumableTypes = 'CONSUMABLE_TYPE',
  Diseases = 'DISEASE',
  Weed = 'WEED',
  Vermins = 'VERMIN',
  Soils = 'SOILS',
  Polygon = 'POLYGON',
  ConsumableRatio = 'CONSUMABLE_RATIO',
  FieldConsumable = 'FIELD_CONSUMABLE',
  SoilHumidity = 'SOIL_HUMIDITY',
  CropDevelopmentPhases = 'CROP_DEVELOPMENT_PHASE',
  CropDevelopmentIndicators = 'CROP_DEVELOPMENT_INDICATORS',
  Threats = 'THREATS',
  CartogramYield = 'CARTOGRAM_YIELD',
  FieldLayers = 'FIELD_LAYERS',
  ReportSettings = 'REPORT_SETTINGS',
}
